import * as FromSearchNLP from 'reducers/searchNLP/selectors';

export const SLICE = 'searchNLP';

export const getPendingSearchView = state =>
  FromSearchNLP.getPendingSearchView(state[SLICE]);

export const getShowNLPFilterModal = state =>
  FromSearchNLP.getShowNLPFilterModal(state[SLICE]);

export const getNLPModalState = state =>
  FromSearchNLP.getNLPModalState(state[SLICE]);

export const getAISearchData = state =>
  FromSearchNLP.getAISearchData(state[SLICE]);

export const getAiFeedbackSubject = state =>
  FromSearchNLP.getAiFeedbackSubject(state[SLICE]);

export const getOrgAiFeedbackSubject = orgSessionId => state =>
  FromSearchNLP.getOrgAiFeedbackSubject(state[SLICE], orgSessionId);

export const getShowAISearchFeedbackModal = state =>
  FromSearchNLP.getShowAISearchFeedbackModal(state[SLICE]);

export const getRecentSearches = state =>
  FromSearchNLP.getRecentSearches(state[SLICE]);

export const getPendingAiSessionId = state =>
  FromSearchNLP.getPendingAiSessionId(state[SLICE]);

export const getConversationalMessages = state =>
  FromSearchNLP.getConversationalMessages(state[SLICE]);

export const getActiveAiSessionId = state =>
  FromSearchNLP.getActiveAiSessionId(state[SLICE]);

export const getFollowUpQueries = state =>
  FromSearchNLP.getFollowUpQueries(state[SLICE]);

export const getSessionFeedback = (state, sessionId) =>
  FromSearchNLP.getSessionFeedback(state[SLICE], sessionId);

export const getAiSession = sessionId => state =>
  FromSearchNLP.getAiSession(state[SLICE], sessionId);
